module.exports = __webpack_public_path__ + "static/media/CAL2.42585073.svg";